import { IMiddlewareEvent } from 'mobx-state-tree';

const MSTGQL_MUTATE_ACTION = 'mutate';

const isMstGqlAction = (call: IMiddlewareEvent) => (
  call.type === 'action' && call.name === MSTGQL_MUTATE_ACTION
);

/*
 * Listen to all outgoing mutations and disable the Undo/Redo buttons until a
 * WS event updates the PlanningActions Store
 */
export default (call: IMiddlewareEvent, next: (actionCall: IMiddlewareEvent, callback?: (value: any) => any) => void) => {
  if (isMstGqlAction(call)) {
    call.tree.planningActions.setIsLoading(true);
  }

  return next(call);
};
